import React from 'react';

import { Box, Text, Tooltip } from '@chakra-ui/react';

const Information = ({ title, information, mt }) => {

  return (
    <Box 
      display="block"
      mt={mt ? mt : "15px"} 
    >
      <Text
        fontWeight={600}
        fontSize="14px"
        lineHeight="19.6px"
        color="#000"
        whiteSpace="nowrap"
      >
        {title}
      </Text>
      <Tooltip
        label={information}
      >
        <Text
          ml={{ base: "0px", sm: "5px" }}
          fontWeight={500}
          fontSize="14px"
          lineHeight="19.6px"
          color="#6B6C71"
        >
          {information}
        </Text>
      </Tooltip>
    </Box>
  );
}

export default Information;